import * as React from "react";
import { AuthUser } from "@mancala/core";

// The signed-in user (a guest too), once the session has started; the header's account menu reads it on every page.
export const AuthUserContext = React.createContext<AuthUser | undefined>(undefined);
